import { useState, useEffect } from 'react';
import { SellerEventsPage } from './seller/SellerEventsPage';
import { DesktopSellerEventsPage } from './desktop/DesktopSellerEventsPage';

export function ResponsiveSellerEventsPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <SellerEventsPage /> : <DesktopSellerEventsPage />;
}